import clsx from "clsx";
import { IconProps } from "@/types/icons";
import { createColorClasses } from "@/theme/colors";

export const Phone = ({
  width = 18,
  height = 18,
  className,
  color,
  decorative = false,
  ariaLabel = "Phone",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 18 18"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.3"
        d="M14.276 10.59a1.646 1.646 0 0 0-2.193-.121c-.097.077-.05.036-1.298 1.283a.4.4 0 0 1-.386.106A6.87 6.87 0 0 1 5.44 6.9a.4.4 0 0 1 .106-.387c1.17-1.17 1.224-1.219 1.275-1.287a1.645 1.645 0 0 0-.113-2.203L4.316.632a1.65 1.65 0 0 0-2.382.056 5 5 0 0 0-.347.474C.361 3.007-.093 5.138.274 7.352c1.097 6.62 9.67 12.89 16.199 8.127a1.65 1.65 0 0 0 .196-2.497zM3.082.875a.93.93 0 0 1 .724.268c2.619 2.618 2.405 2.4 2.46 2.468a.93.93 0 0 1 .05 1.086c-.07.105-.129.155-.55.577l-3.63-3.63c.255-.39.452-.73.946-.769ZM.987 7.235c-.29-1.745-.023-3.433.772-4.947l3.496 3.496-.22.22a1.13 1.13 0 0 0-.294 1.075 7.59 7.59 0 0 0 5.479 5.479 1.13 1.13 0 0 0 1.076-.295l.219-.22 3.497 3.497C9.065 18.66 1.936 12.959.987 7.234Zm15.438 6.982c-.04.512-.405.702-.769.946l-3.63-3.63c.392-.391.49-.498.578-.55a.926.926 0 0 1 1.161.118l2.392 2.392a.92.92 0 0 1 .268.724Z"
      />
    </svg>
  );
};
